<template>
    <div
        class  = "w-100 lm-border pa-2"
        style  = "height: 216px;"
    >
        <div class="primary white--text" style="border-bottom-style: solid; border-bottom-width: 1px; font-size: 15px; font-weight: 500; height: 24px; padding-left: 4px; padding-top: 1px">
            {{ title }}
        </div>
        <div class="v-flex mt-2" style="min-height: 36px;">
            <f-enum-select
                v-model       = "tzbComponent.modernization"
                :label        = "$t('unit.tzb.modernization.measure')"
                class         = "measure-type"
                module        = "msd"
                type          = "tzbModernizationType"
                :readonly     = "readonly"
                :hide-details = "true"
            />
            <f-currency-field
                v-if          = "tzbComponent.modernization && tzbComponent.modernization.id !== 1"
                :label        = "$t('unit.tzb.modernization.costs')"
                v-model       = "tzbComponent.costs"
                class         = "money measure-costs"
                :hide-details = "true"
                :readonly     = "readonly"
            />
        </div>

        <div class = "measure-note">
            <v-textarea
                :label         = "$t('unit.tzb.modernization.note')"
                v-model        = "tzbComponent.note"
                rows           = "3"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
                hide-details   = "true"
                :readonly      = "readonly"
                no-resize
            />
        </div>
    </div>
</template>

<script>
import FCurrencyField from "@/modules/core/components/utils/FCurrencyField.vue";
import FEnumSelect    from "@/modules/core/components/utils/FEnumSelect.vue";

export default {
    name: "PSiteTzbCalculationComponent",

    components: {
        FEnumSelect,
        FCurrencyField
    },

    props: {
        title: {

        },

        tzbComponent: {
        },

        border: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        readonly: {
        }
    },

    computed: {
        text () {
            if (!this.tzbComponent.note) {
                return "";
            }

            return this.tzbComponent.note.replaceAll ("\\n", "<br>");
        }
    },

    data: () => ({
        action: null,
    }),
}
</script>

<style scoped>

.money ::v-deep input{
    text-align: right;
}

.measure-type {
    max-width: 50%;
    width: 50%;
    padding-right: 8px;
}

.measure-costs {
    max-width: 50%;
    width: 50%;
    padding-left: 8px;
    padding-right: 28px;
}

.measure-note {
    height: calc(100% - 64px);
    margin-top: 22px
}

</style>